import Spinner from '@youversion/design-system-icons/lib/Spinner';
import Modal from 'components/ui/modal';
import { useTranslation } from 'next-i18next';

export default function ProcessingDialog() {
  const { t } = useTranslation('common');

  return (
    <Modal>
      <div className='flex flex-col justify-between items-center bg-canvas-light dark:bg-canvas-dark'>
        <div className='flex flex-col text-black dark:text-white items-center mbs-22'>
          <Spinner className='mbe-10' dur={0.9} size='64' />
          <div className='text-28'>{t('giving.progress.processing_ellipsis')}</div>
        </div>
      </div>
    </Modal>
  );
}
